'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactClass = require('react-class');

var _reactClass2 = _interopRequireDefault(_reactClass);

var _objectAssign = require('object-assign');

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _hasTouch = require('has-touch');

var _hasTouch2 = _interopRequireDefault(_hasTouch);

var _reactNotifyResize = require('react-notify-resize');

var _lodash = require('lodash.debounce');

var _lodash2 = _interopRequireDefault(_lodash);

var _reactFlex = require('react-flex');

var _reactMotion = require('react-motion');

var _join = require('../join');

var _join2 = _interopRequireDefault(_join);

var _bemFactory = require('../bemFactory');

var _bemFactory2 = _interopRequireDefault(_bemFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CLASS_NAME = 'react-tab-panel__tab-strip-scroll-tool';

var bem = (0, _bemFactory2.default)(CLASS_NAME);
var m = function m(name) {
  return bem(null, name);
};

var styles = {};

var ARROWS = {
  right: _react2.default.createElement(
    'svg',
    { className: (0, _join2.default)(bem('arrow'), bem('arrow', 'right')), height: '18', viewBox: '0 0 24 24', width: '18', xmlns: 'http://www.w3.org/2000/svg' },
    _react2.default.createElement('path', { d: 'M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z' }),
    _react2.default.createElement('path', { d: 'M0-.25h24v24H0z', fill: 'none' })
  ),

  left: _react2.default.createElement(
    'svg',
    { className: (0, _join2.default)(bem('arrow'), bem('arrow', 'left')), height: '18', viewBox: '0 0 24 24', width: '18', xmlns: 'http://www.w3.org/2000/svg' },
    _react2.default.createElement('path', { d: 'M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z' }),
    _react2.default.createElement('path', { d: 'M0-.5h24v24H0z', fill: 'none' })
  ),

  down: _react2.default.createElement(
    'svg',
    { className: (0, _join2.default)(bem('arrow'), bem('arrow', 'down')), height: '18', viewBox: '0 0 24 24', width: '18', xmlns: 'http://www.w3.org/2000/svg' },
    _react2.default.createElement('path', { d: 'M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z' }),
    _react2.default.createElement('path', { d: 'M0-.75h24v24H0z', fill: 'none' })
  ),

  up: _react2.default.createElement(
    'svg',
    { className: (0, _join2.default)(bem('arrow'), bem('arrow', 'up')), height: '18', viewBox: '0 0 24 24', width: '18', xmlns: 'http://www.w3.org/2000/svg' },
    _react2.default.createElement('path', { d: 'M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z' }),
    _react2.default.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
  )
};

var emptyFn = function emptyFn() {};
var stop = function stop(e) {
  e.preventDefault();
  e.stopPropagation();
};

var Scroller = function (_Component) {
  _inherits(Scroller, _Component);

  function Scroller(props) {
    _classCallCheck(this, Scroller);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Scroller).call(this, props));

    _this.scrollInfo = {
      scrollPos: 0,
      adjustScroll: true,

      hasStartScroll: false,
      hasEndScroll: false,

      scrollerSize: {
        start: 0,
        end: 0
      }
    };

    _this.state = {
      scrolling: false,
      activeScroll: 0
    };

    _this.onResize = (0, _lodash2.default)(_this.onResize, 50, { leading: false, trailing: true });
    return _this;
  }

  _createClass(Scroller, [{
    key: 'getOffsetSizeName',
    value: function getOffsetSizeName() {
      var tabPosition = this.props.tabPosition;

      return tabPosition == 'top' || tabPosition == 'bottom' ? 'offsetWidth' : 'offsetHeight';
    }
  }, {
    key: 'getSizeName',
    value: function getSizeName() {
      var tabPosition = this.props.tabPosition;

      return tabPosition == 'top' || tabPosition == 'bottom' ? 'width' : 'height';
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var name = this.getOffsetSizeName();

      this.scrollInfo.scrollerSize = {
        start: (0, _reactDom.findDOMNode)(this.refs.start)[name],
        end: (0, _reactDom.findDOMNode)(this.refs.end)[name]
      };

      this.syncScroll({ force: true });
    }
  }, {
    key: 'onResize',
    value: function onResize() {
      delete this.currentListSize;
      delete this.availableSize;

      this.syncScroll({ force: true });
    }
  }, {
    key: 'syncScroll',
    value: function syncScroll() {
      var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

      var force = _ref.force;

      this.updateScrollInfo();
      this.doScroll(0, null, { force: force });
    }
  }, {
    key: 'scrollIntoView',
    value: function scrollIntoView(domNode) {
      if (domNode) {
        var rect = domNode.getBoundingClientRect();
        var mainRect = (0, _reactDom.findDOMNode)(this.wrapper || this).getBoundingClientRect();

        var tabPosition = this.props.tabPosition;

        var startSideName = tabPosition == 'top' || tabPosition == 'bottom' ? 'left' : 'top';
        var endSideName = tabPosition == 'top' || tabPosition == 'bottom' ? 'right' : 'bottom';

        var startDiff = rect[startSideName] - mainRect[startSideName];
        var endDiff = rect[endSideName] - mainRect[endSideName];

        var scrollIntoViewOffset = this.props.scrollIntoViewOffset;

        if (startDiff < 0) {
          this.doScroll(-startDiff + scrollIntoViewOffset, -1);
        } else if (endDiff > 0) {
          this.doScroll(endDiff + scrollIntoViewOffset, 1);
        }
      }
    }
  }, {
    key: 'doScroll',
    value: function doScroll(direction, step) {
      var _ref2 = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

      var force = _ref2.force;

      var scrollInfo = this.scrollInfo;

      var newScrollPos = scrollInfo.scrollPos + direction * (step || this.props.scrollStep);

      this.setScrollPosition(newScrollPos, { force: force });
    }
  }, {
    key: 'scrollBy',
    value: function scrollBy(offset, direction) {
      var _ref3 = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

      var force = _ref3.force;

      var scrollInfo = this.scrollInfo;

      var newScrollPos = scrollInfo.scrollPos + direction * offset;

      this.setScrollPosition(newScrollPos, { force: force });
    }
  }, {
    key: 'onClick',
    value: function onClick(direction) {
      var offset = this.getAvailableSize();

      this.scrollBy(offset, direction);
    }
  }, {
    key: 'setScrollPosition',
    value: function setScrollPosition(scrollPos) {
      var _ref4 = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

      var force = _ref4.force;

      var scrollInfo = this.scrollInfo;

      if (scrollPos > scrollInfo.maxScrollPos) {
        scrollPos = scrollInfo.maxScrollPos;
      }

      if (scrollPos < 0) {
        scrollPos = 0;
      }

      if (scrollPos === scrollInfo.scrollPos && force !== true) {
        return;
      }

      (0, _objectAssign2.default)(scrollInfo, {

        hasStartScroll: scrollPos !== 0,
        hasEndScroll: scrollPos < scrollInfo.maxScrollPos,

        scrollPos: scrollPos
      });

      this.setState({});
    }
  }, {
    key: 'updateScrollInfo',
    value: function updateScrollInfo() {

      var availableSize = this.getAvailableSize();
      var listSize = this.getCurrentListSize();

      var scrollInfo = (0, _objectAssign2.default)(this.scrollInfo, {
        availableSize: availableSize,
        listSize: listSize
      });

      if (listSize > availableSize) {
        scrollInfo.maxScrollPos = listSize - availableSize;
      } else {
        scrollInfo.maxScrollPos = 0;
      }

      scrollInfo.hasStartScroll = scrollInfo.scrollPos != 0;
      scrollInfo.hasEndScroll = scrollInfo.scrollPos < scrollInfo.maxScrollPos;
    }
  }, {
    key: 'handleScrollMax',
    value: function handleScrollMax(direction, event) {
      stop(event);

      var maxPos = direction == -1 ? 0 : this.scrollInfo.maxScrollPos;

      this.setScrollPosition(maxPos);
    }
  }, {
    key: 'startScroll',
    value: function startScroll(direction, event) {
      var _this2 = this;

      var eventName = _hasTouch2.default ? 'touchend' : 'mouseup';

      var mouseUpListener = function mouseUpListener() {
        _this2.stopScroll();
        global.removeEventListener(eventName, mouseUpListener);
      };

      global.addEventListener(eventName, mouseUpListener);

      this.scrollInterval = global.setInterval(this.doScroll.bind(this, direction), this.props.scrollSpeed);

      this.setState({
        scrolling: true,
        activeScroll: direction
      });
    }
  }, {
    key: 'stopScroll',
    value: function stopScroll() {

      global.clearInterval(this.scrollInterval);

      this.setState({
        scrolling: false,
        activeScroll: 0
      });
    }
  }, {
    key: 'renderScroller',
    value: function renderScroller(direction) {
      var _props = this.props;
      var scroller = _props.scroller;
      var vertical = _props.vertical;
      var tabPosition = _props.tabPosition;


      if (!scroller) {
        return null;
      }

      var directionName = vertical ? direction == -1 ? 'up' : 'down' : direction == -1 ? 'left' : 'right';

      var arrowName = tabPosition == 'top' || tabPosition == 'bottom' ? direction == -1 ? 'left' : 'right' : direction == -1 ? 'up' : 'down';

      var behavior = typeof scroller === 'boolean' ? scroller ? 'on' : 'off' : 'auto';

      var scrollInfo = this.scrollInfo;
      var disabled = direction == -1 ? !scrollInfo.hasStartScroll : !scrollInfo.hasEndScroll;

      var className = (0, _join2.default)(CLASS_NAME, m(behavior), m('direction-' + arrowName), m('tab-position-' + tabPosition), this.state.activeScroll == direction ? m('active') : '', scroller === 'auto' && disabled && m('hidden'), scroller === true && disabled && m('disabled'));

      var onClick = !disabled && this.props.scrollOnClick ? this.onClick.bind(this, direction) : emptyFn;

      var onMouseDown = !disabled && !this.props.scrollOnClick ? this.startScroll.bind(this, direction) : emptyFn;

      var onDoubleClick = !disabled ? this.handleScrollMax.bind(this, direction) : emptyFn;

      var scrollerProps = {
        ref: direction == -1 ? 'start' : 'end',
        disabled: disabled,
        className: className,
        onClick: onClick,
        onMouseDown: !_hasTouch2.default && onMouseDown,
        onTouchStart: _hasTouch2.default && onMouseDown,
        onDoubleClick: onDoubleClick,
        children: ARROWS[arrowName]
      };

      var result = void 0;

      if (this.props.renderScroller) {
        result = this.props.renderScroller(scrollerProps);
      }

      if (result === undefined) {
        result = _react2.default.createElement('div', scrollerProps);
      }

      return result;
    }

    /**
     * Cache the current list width on this instance.
     *
     * It will be invalidated by onResize
     *
     * @return {Number}
     */

  }, {
    key: 'getCurrentListSize',
    value: function getCurrentListSize() {
      return this.currentListSize = this.currentListSize || (0, _reactDom.findDOMNode)(this.strip)[this.getOffsetSizeName()];
    }

    /**
     * Cache the available width on this instance.
     *
     * It will be invalidated by onResize
     *
     * @return {Number}
     */

  }, {
    key: 'getAvailableSize',
    value: function getAvailableSize() {
      return this.availableSize = this.availableSize || (0, _reactDom.findDOMNode)(this.wrapper || this)[this.getOffsetSizeName()];
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var props = this.props;
      var scroller = props.scroller;
      var tabPosition = props.tabPosition;

      var scrollInfo = this.scrollInfo;

      var scrollStyleName = tabPosition == 'top' || tabPosition == 'bottom' ? 'left' : 'top';

      var style = _defineProperty({}, scrollStyleName, (0, _reactMotion.spring)(-scrollInfo.scrollPos, props.scrollSpringConfig));

      var resizer = _react2.default.createElement(_reactNotifyResize.NotifyResize, { key: 'resizer', onResize: this.onResize });
      var children = [props.childProps.children, resizer];

      return _react2.default.createElement(
        _reactFlex.Flex,
        _extends({ ref: null }, props),
        resizer,
        this.renderScroller(-1),
        _react2.default.createElement(
          _reactMotion.Motion,
          { style: style },
          function (_ref5) {
            var scrollValue = _ref5[scrollStyleName];

            var contents = _react2.default.createElement(_reactFlex.Flex, _extends({}, props.childProps, { ref: function ref(c) {
                return _this3.strip = c;
              }, children: children, style: _defineProperty({}, scrollStyleName, scrollValue) }));

            if (scroller === true) {
              //always show
              return _react2.default.createElement(
                _reactFlex.Flex,
                { ref: function ref(c) {
                    return _this3.wrapper = c;
                  }, className: 'react-tab-panel__tab-strip-scroll-wrap', row: true, flexGrow: 1, flexShrink: 1, wrap: false, alignItems: 'stretch' },
                contents
              );
            }
            return contents;
          }
        ),
        this.renderScroller(1)
      );
    }
  }]);

  return Scroller;
}(_reactClass2.default);

exports.default = Scroller;


Scroller.propTypes = {
  /**
   * When true, scrolling will only happen on click
   * and will scroll all visible tabs to a given direction
   *
   * When false, scrolling will happen on mouseDown
   *
   * @type {Boolean}
   */
  scrollOnClick: _react.PropTypes.bool,

  scroller: _react.PropTypes.oneOf(['auto', false, true])
};

Scroller.defaultProps = _defineProperty({
  onScrollEnd: function onScrollEnd() {},
  scrollStep: 15,
  scrollSpeed: 10,
  scrollSpringConfig: {
    stiffness: 370,
    damping: 60
  },
  scrollIntoViewOffset: 50,
  onScrollerClick: function onScrollerClick() {}
}, 'onScrollEnd', function onScrollEnd() {});


//////////////////
// WEBPACK FOOTER
// ./~/react-tab-panel/lib/TabStrip/Scroller.js
// module id = 1891
// module chunks = 0